import { AuthConfig } from "angular-oauth2-oidc";

export const OAuthConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: "",

  // The SPA's id. The SPA is registerd with this id at the auth-server
  // Following clientId is needed only for local environment and it must be available in IT_Clients table
  clientId: "demoIdentityServer",
  scope: "openid profile offline_access",

  // URL of the SPA to redirect the user to after login
  redirectUri: "/callback",
  // requireHttps: false, //remove this later - todo
  // Login Url of the Identity Provider
  //loginUrl: '/connect/authorize',

  // Logout Url of the Identity Provider
  //logoutUrl: '/connect/endsession',
  // URL of the SPA to redirect the user to after logout
  postLogoutRedirectUri: "/callback",

  // For refresh tokens

  useSilentRefresh: false, // Use silent refresh
  silentRefreshTimeout: 5000,
  timeoutFactor: 0.75, // Refresh token before expiry
  sessionChecksEnabled: false,
  // showDebugInformation: true, // Debugging purposes
  // clearHashAfterLogin: false,   // Prevent URL pollution
  // silentRefreshRedirectUri: '/refresh-token',
};
